import { Link } from "react-router-dom";
import { t } from "ttag";

import { usePortalUserStore } from "@/app/stores";
import { useOngoingSessions } from "@/features/coaching/hooks";
import { Badge, NotificationBar, StarsIcon } from "@/shared/ui";

export const LiveSessionNotificationBar = () => {
  const { data: ongoingSessions } = useOngoingSessions();

  const firstOngoingSession = ongoingSessions?.[0];

  const canAccessCoachingSessions = usePortalUserStore(
    (state) => state.canAccessCoachingSessions,
  );

  if (!canAccessCoachingSessions || !firstOngoingSession) {
    return null;
  }

  return (
    <NotificationBar className="flex-col gap-2 md:flex-row md:gap-4">
      <div className="flex gap-1 md:items-center">
        <h2 className="inline-flex grow items-start gap-1 text-sm font-semibold md:text-base">
          <StarsIcon className="size-4 translate-y-0.5 md:translate-y-1" />
          {firstOngoingSession.title}
        </h2>

        <Badge size="x-small" className="gap-1">
          <div className="size-2 animate-pulse rounded-full bg-red-600" />
          {t`Live!`}
        </Badge>
      </div>

      {firstOngoingSession.joinUrl && (
        <Link
          to={firstOngoingSession.joinUrl}
          target="_blank"
          rel="noreferrer"
          className="pl-5 text-xs font-medium text-primary-950 underline md:pl-0 md:text-base"
        >
          {t`Join now`}
        </Link>
      )}
    </NotificationBar>
  );
};
